import React from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';

import { fullName } from '../../../users/utils';
import storedUserInfo from '../../../utils/session-data/user-info';
import SignOutButton from '../SignOutButton';
import getUserInitials from '../utils';

function UserIconPopoverDetails() {
  const currentUser = storedUserInfo.get();
  const { lastName, firstName, email, roles, salesUnit, salesTeam } =
    currentUser || {};
  return (
    <Dropdown>
      <DropdownToggle className="user-nav" data-toggle="dropdown">
        {getUserInitials(firstName, lastName)}
      </DropdownToggle>
      <DropdownMenu className="user-hover-menu" right>
        <DropdownItem header>Name:</DropdownItem>
        <DropdownItem className="fullName" text>
          {fullName(currentUser)}
        </DropdownItem>
        <DropdownItem header>Email:</DropdownItem>
        <DropdownItem className="email" text>
          {email}
        </DropdownItem>
        <DropdownItem header>Roles:</DropdownItem>
        <DropdownItem className="roles" text>
          {roles && roles.length ? roles.join(', ') : '-'}
        </DropdownItem>
        <DropdownItem header>Sales Unit:</DropdownItem>
        <DropdownItem className="sales-unit" text>
          {salesUnit || '-'}
        </DropdownItem>
        <DropdownItem header>Sales Team:</DropdownItem>
        <DropdownItem className="sales-team" text>
          {salesTeam || '-'}
        </DropdownItem>
        <DropdownItem divider />
        <SignOutButton />
      </DropdownMenu>
    </Dropdown>
  );
}

export default UserIconPopoverDetails;
